export const MapReportStatuses = {
  All: 'all',
  Waiting: 'waiting',
  Completed: 'completed',
  Rejected: 'rejected',
}
